export enum CreditRiskLevelMetric {
  CQS = 'cqs',
  CRL = 'crl',
  FAS = 'fas',
  ACR = 'acr',
}

export enum HighLowCreditRiskLevelMetric {
  VERY_HIGH = 'Very High',
  HIGH = 'High',
  MODERATE = 'Moderate',
  LOW = 'Low',
  VERY_LOW = 'Very Low',
  NOT_AVAILABLE = 'Not Available',
}

export enum HighLowBriefCreditRiskLevelMetric {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export enum MigrationMetric {
  UPGRADE = 'Upgrade',
  NO_CHANGE = 'No change',
  DOWNGRADE = 'Downgrade',
}

export enum MiscStateMetric {
  PRIVATE = 'Private',
  IN_DEFAULT = 'In Default',
  ACQUIRED = 'Acquired',
  EXCLUDE_ACQUIRED_DEFAULTED = 'Exclude Acquired & Defaulted',
}

export enum PositiveNegativeCreditRiskLevelMetric {
  POSITIVE = 'Positive',
  STABLE = 'Stable',
  NEGATIVE = 'Negative',
  NOT_AVAILABLE = 'Not Available',
}

export enum AcrTierMetric {
  AAA = 'AAA/AA',
  A = 'A',
  BBB = 'BBB',
  BB = 'BB',
  B = 'B',
  CCC = 'CCC/C',
  D = 'D',
  NOT_AVAILABLE = 'Not Available',
}

export enum DeteriorationImprovementMetric {
  STRONG_DETERIORATION = 'Strong Deterioration',
  MODERATE_DETERIORATION = 'Moderate Deterioration',
  STABLE = 'Stable',
  MODERATE_IMPROVEMENT = 'Moderate Improvement',
  STRONG_IMPROVEMENT = 'Strong Improvement',
}

export enum DifferentialMetric {
  HIGH_NEGATIVE_DIFFERENTIAL = 'High Negative Differential',
  MODERATE_NEGATIVE_DIFFERENTIAL = 'Moderate Negative Differential',
  NEUTRAL_DIFFERENTIAL = 'Neutral Differential',
  MODERATE_POSITIVE_DIFFERENTIAL = 'Moderate Positive Differential',
  HIGH_POSITIVE_DIFFERENTIAL = 'High Positive Differential',
  NOT_AVAILABLE = 'Not Available',
}

export type RiskProductKeyMetric =
  | HighLowCreditRiskLevelMetric
  | PositiveNegativeCreditRiskLevelMetric
  | DeteriorationImprovementMetric
  | DifferentialMetric
  | AcrTierMetric
  | string;

export interface CreditRiskLevelDto {
  companyIds: string[];
  key: RiskProductKeyMetric;
}

export interface CreditRiskLevelsDto {
  data: {
    result: CreditRiskLevelDto[];
  };
}
